import React from 'react';

const LinkCreate = React.lazy(() => import('./LinkCreate'));
const LinkComplete = React.lazy(() => import('./LinkComplete'));
// const LinkEdit = React.lazy(() => import('./LinkEdit'));
const LinkManagement = React.lazy(() => import('./LinkManagement'));

export { LinkCreate, LinkManagement, LinkComplete };
